import AppModel from '@/store/modules/app';
import { datetime } from './filter';
export function timeFix() {
  const time = new Date();
  const hour = time.getHours();
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好';
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了'];
  const index = Math.floor(Math.random() * arr.length);
  return arr[index];
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents') as any;
  event.initEvent('resize', true, true);
  event.eventType = 'message';
  window.dispatchEvent(event);
}

export function handleScrollHeader(callback: any) {
  let timer: any = 0;

  let beforeScrollTop = window.pageYOffset;
  callback = callback || function() {};
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        let direction = 'up';
        const afterScrollTop = window.pageYOffset;
        const delta = afterScrollTop - beforeScrollTop;
        if (delta === 0) {
          return false;
        }
        direction = delta > 0 ? 'down' : 'up';
        callback(direction);
        beforeScrollTop = afterScrollTop;
      }, 50);
    },
    false
  );
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return;
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id)!);
  }, timeout);
}

/** 初始化页面 收起左侧导航栏 针对1280屏幕 */
export function isSmallScreen() {
  console.log('初始化页面 收起左侧导航栏 针对1280屏幕');
  const cWidth = document.documentElement.clientWidth; // 页面窗口可视大小
  cWidth < 1281 ? AppModel.setCOLLAPSED(true) : AppModel.setCOLLAPSED(false);
}

/**
 * 判断对象数组每一个对象元素的属性是否为空
 * @param objArr 要处理的对象数组
 * @param arr 你想要判断的属性，不传则判断全部属性
 */
export function isEachItemEmpty(objArr: any, arr?: string[] | undefined) {
  return new Promise((resolve, reject) => {
    try {
      for (const r of objArr) {
        let pickedObj = r;
        if (arr) {
          pickedObj = arr.reduce((iter: any, val: any) => (val in r && (iter[val] = r[val]), iter), {});
        }
        if (
          Object.values(pickedObj).includes('') ||
          Object.values(pickedObj).includes(null) ||
          Object.values(pickedObj).includes(undefined)
        ) {
          resolve(true);
        }
      }
      resolve(false);
    } catch (error) {
      console.log('error:', error.toString());
      reject(error);
    }
  });
}

/** 从对象数组中，选取我需要的对象属性
 * obj：需要处理的对象
 * arr：需要的字段名
 * exp:  pickINeed({age:1,name:'lisi1'},['age'])  => {age:1}
 */
export function pickINeed(obj: any, arr: string[]) {
  return arr.reduce((iter: any, val: any) => (val in obj && (iter[val] = obj[val]), iter), {});
}

export async function downloadBlob(blobData: Blob, fileName: string = datetime(Date.now()) as string) {
  try {
    // 创建一个临时 URL 指向 Blob 数据
    const url = URL.createObjectURL(blobData);

    // 创建一个虚拟的 a 标签,模拟点击下载
    const link = document.createElement('a');
    link.href = url;
    if (fileName) link.setAttribute('download', fileName);

    // 将 a 标签添加到 DOM 中并触发点击事件
    document.body.appendChild(link);
    link.click();

    // 删除临时创建的 a 标签
    document.body.removeChild(link);

    // 释放 Blob 数据对应的临时 URL
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('下载失败:', error);
  }
}
